import { render, staticRenderFns } from "./veStuAssocRelationEdit.vue?vue&type=template&id=4f686fd0&scoped=true"
import script from "./veStuAssocRelationEdit.vue?vue&type=script&lang=js"
export * from "./veStuAssocRelationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f686fd0",
  null
  
)

export default component.exports